import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import classNames from 'classnames';
import { getApiUrl } from '../../../utils/apiConfig';

const EstadoOfertaDropdown = ({ selectedVisita, setSelectedVisita }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);
  const [estadoOptions, setEstadoOptions] = useState([]);

  useEffect(() => {
    const fetchEstados = async () => {
      try {
        const res = await axios.get(getApiUrl('/api/estadoOferta'));
        const estados = res.data.map((estado) => ({
          value: estado.Estado,
          label: estado.Estado,
          color: '#eee',
        }));
        setEstadoOptions(estados);
      } catch (err) {
        console.error('Error al cargar estados de oferta:', err);
      }
    };

    fetchEstados();
  }, []);

  // const selected = estadoOptions.find((opt) => opt.value === selectedVisita?.EstadoOferta) || { value: '', label: '', color: '#eee' };

  const selected = {
    value: selectedVisita?.EstadoOferta || '',
    label: selectedVisita?.EstadoOferta || '',
    color: '#eee'
  };

  const placeholder = 'Selecciona estado de oferta';
  const hasSelection = Boolean((selectedVisita?.EstadoOferta || '').trim());


  // Cerrar dropdown al hacer clic fuera
  useEffect(() => {
    if (!isOpen) return;
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    // <div className="relative w-full" ref={containerRef}>
    //   <label className="block mb-1 text-xs font-medium text-gray-700 truncate">
    //     Estado Oferta*
    //   </label>
    //   <button
    //     onClick={() => setIsOpen(!isOpen)}
    //     className="DropDownName w-full p-2 border rounded shadow-sm bg-white text-left flex justify-between items-center"
    //   >
    //     <span className='truncate'>{selected.label}</span>
    //     <svg
    //       className="w-4 h-4 text-gray-500"
    //       fill="none"
    //       stroke="currentColor"
    //       viewBox="0 0 24 24"
    //     >
    //       <path
    //         strokeLinecap="round"
    //         strokeLinejoin="round"
    //         strokeWidth={2}
    //         d="M19 9l-7 7-7-7"
    //       />
    //     </svg>
    //   </button>
    //   {isOpen && (
    //     <ul className="absolute z-10 mt-1 w-full bg-white border rounded shadow-lg max-h-60 overflow-auto">
    //       {estadoOptions.map((option) => (
    //         <li
    //           key={option.value}
    //           onClick={() => {
    //             setSelectedVisita({
    //               ...selectedVisita,
    //               EstadoOferta: option.value,
    //             });
    //             setIsOpen(false);
    //           }}
    //           className={classNames(
    //             'cursor-pointer px-4 py-2 text-sm transition-colors',
    //             {
    //               'bg-gray-100': selectedVisita.EstadoOferta === option.value,
    //             }
    //           )}
    //           style={{
    //             backgroundColor:
    //               selectedVisita.EstadoOferta === option.value
    //                 ? '#f3f4f6'
    //                 : 'white',
    //           }}
    //           onMouseEnter={(e) =>
    //             (e.currentTarget.style.backgroundColor = option.color)
    //           }
    //           onMouseLeave={(e) =>
    //             (e.currentTarget.style.backgroundColor =
    //               selectedVisita.EstadoOferta === option.value
    //                 ? '#f3f4f6'
    //                 : 'white')
    //           }
    //         >
    //           {option.label}
    //         </li>
    //       ))}
    //     </ul>
    //   )}
    // </div>

    <div className="relative w-full" ref={containerRef}>
      <label className="block mb-1 text-xs font-medium text-gray-700 truncate">Estado de Oferta*</label>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="DropDownName w-full p-2 shadow-sm border rounded bg-white flex justify-between items-center"
        aria-haspopup="listbox"
        aria-expanded={isOpen}
        title={hasSelection ? selected.label : placeholder}
      >
        <span className={`truncate ${hasSelection ? '' : 'text-gray-400'}`}>
          {hasSelection ? selected.label : placeholder}
        </span>
        <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      {isOpen && (
        <ul className="absolute z-10 mt-1 w-full bg-white border rounded shadow-lg max-h-60 overflow-auto" role="listbox">
          <li
            onClick={() => { setSelectedVisita({ ...selectedVisita, EstadoOferta: '' }); setIsOpen(false); }}
            className={`cursor-pointer px-4 py-2 text-sm hover:bg-blue-50 hover:text-blue-700 transition-colors ${!hasSelection ? 'bg-blue-50 text-blue-700 font-medium' : ''}`}
            role="option"
            aria-selected={!hasSelection}
          >
            {placeholder}
          </li>
          {estadoOptions.map(option => (
            <li
              key={option.value}
              onClick={() => {
                setSelectedVisita({ ...selectedVisita, EstadoOferta: option.value });
                setIsOpen(false);
              }}
              className={classNames(
                'cursor-pointer px-4 py-2 text-sm hover:bg-blue-50 hover:text-blue-700 transition-colors',
                { 'bg-blue-50 text-blue-700 font-medium': (selectedVisita.EstadoOferta?.trim() || '') === option.value }
              )}
              role="option"
              aria-selected={(selectedVisita.EstadoOferta?.trim() || '') === option.value}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>

  );
};

export default EstadoOfertaDropdown;


// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import classNames from 'classnames';

// const estadoColors = [
//   '#00a6f4', // Azul base
//   '#ffb03a', // Naranja vibrante
//   '#00d48b', // Verde menta vibrante
//   '#ff6262', // Rojo coral
//   '#7cdaff', // Azul cielo claro
//   '#ffd864', // Amarillo brillante
//   '#8cf2b3', // Verde suave
//   '#ffd0a6', // Naranja pastel
// ];



// const EstadoOfertaDropdown = ({ selectedVisita, setSelectedVisita }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [estadoOptions, setEstadoOptions] = useState([
//     { value: '', label: 'Selecciona...', color: '#9ca3af' },
//   ]);

//   useEffect(() => {
//     const fetchEstados = async () => {
//       try {
//         const res = await axios.get('http://localhost:5000/api/estadoOferta');
//         const estados = res.data.map((estado, idx) => ({
//           value: estado.Estado,
//           label: estado.Estado,
//           color: estadoColors[idx % estadoColors.length],
//         }));
//         setEstadoOptions((prev) => [...prev, ...estados]);
//       } catch (err) {
//         console.error('Error al cargar estados de oferta:', err);
//       }
//     };

//     fetchEstados();
//   }, []);

//   const selected =
//     estadoOptions.find((opt) => opt.value === selectedVisita?.EstadoOferta) ||
//     estadoOptions[0];

//   return (
//     <div className="relative w-full mb-4">
//       <label className="block mb-1 text-sm font-medium text-gray-700">
//         Estado Oferta
//       </label>

//       <button
//         onClick={() => setIsOpen(!isOpen)}
//         className="w-full p-2 border rounded shadow-sm bg-white text-left flex justify-between items-center"
//       >
//         <span
//           className="inline-block px-2 py-1 rounded text-white text-sm"
//           style={{ backgroundColor: selected.color }}
//         >
//           {selected.label}
//         </span>
//         <svg
//           className="w-4 h-4 text-gray-500 ml-2"
//           fill="none"
//           stroke="currentColor"
//           viewBox="0 0 24 24"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             strokeWidth={2}
//             d="M19 9l-7 7-7-7"
//           />
//         </svg>
//       </button>

//       {isOpen && (
//         <ul className="absolute z-10 mt-1 w-full bg-white border rounded shadow-lg max-h-60 overflow-auto">
//           {estadoOptions.map((option) => (
//             <li
//               key={option.value}
//               onClick={() => {
//                 setSelectedVisita({
//                   ...selectedVisita,
//                   EstadoOferta: option.value,
//                 });
//                 setIsOpen(false);
//               }}
//               className="cursor-pointer px-3 py-2 hover:bg-gray-100"
//             >
//               <span
//                 className="inline-block px-2 py-1 rounded text-white text-sm"
//                 style={{ backgroundColor: option.color }}
//               >
//                 {option.label}
//               </span>
//             </li>
//           ))}
//         </ul>
//       )}
//     </div>
//   );
// };

// export default EstadoOfertaDropdown;
